import { collection, getCountFromServer, query, where } from "firebase/firestore";
import { DATABASE } from "../Config/firebase";

/**
 * Transaction / ledger counts for one client. Migrated accounts keep history under the
 * old uid (users.doc_id), so both ids are counted. Returns { error } instead of throwing:
 * a failed count stays visible.
 */
export async function countClientActivity(uid, legacyDocId) {
  const ids = [...new Set([uid, legacyDocId].filter(Boolean))];
  if (!ids.length) return { transactions: 0, ledgers: 0, error: "missing_uid" };
  try {
    const [tx, ledgers] = await Promise.all([
      getCountFromServer(query(collection(DATABASE, "transection_requests"), where("user_id", "in", ids))),
      getCountFromServer(query(collection(DATABASE, "ledgers"), where("user_id", "in", ids))),
    ]);
    return { transactions: tx.data().count, ledgers: ledgers.data().count, error: null };
  } catch (e) {
    return { transactions: null, ledgers: null, error: e.code || "count_failed" };
  }
}

export function hasClientActivity(activity) {
  return !!activity && !activity.error && (activity.transactions > 0 || activity.ledgers > 0);
}
